<template>
  <div class="add-member">
    <q-form @submit.prevent="add_new_member">
      <loading-bar v-if="loading"></loading-bar>
      <label>Add Member</label>
      <q-input v-model="team_data.code" bg-color="positive" reactive-rules label-color="secondary" filled
        label="Team Member Code" :rules="form_rules.team_member" />

      <div class="text-center">
        <div class="the-button">
          <button class="wro-button secondaryButtons"><span>Next</span></button>
          <span class="skew-line-w"></span>
        </div>
      </div>
      <p class="error" v-for="(item, index) in errors" :key="index"> {{item}}</p>

      <!-- <table class="table" cellspacing="0" cellpadding="0">
        <thead>
          <tr>
            <th>Code</th>
            <th>Name/Email</th>
            <th>Invitation</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(member, index) in members" :key="index">
            <td>{{member.code}}</td>
            <td>{{member.name}}<br/>{{member.email}}</td>
            <td>{{member.status === 0 ? 'Pending' : 'Accepted'}}</td>
            <td><i class="fas fa-trash fa-2x" @click="delete_member(member.id, team_id)" /></td>
          </tr>
        </tbody>
      </table> -->
    </q-form>
  </div>
</template>


<script>
import Loading from "@/components/Loading/loading";
import LoadingBar from "@/components/Loading/LoadingBar";
export default {
  name: 'Add-Member',
  components: { LoadingBar, Loading },
  props: ['team_id'],
  data: () => ({
    errors: [],
    team_data: {
      code: null,
      team_id: null,
    },
    loading: false,
    form_rules: {
      team_member: [val => val !== null && val !== '' || 'Please type member id'],
    },
    members: []
  }),
  mounted() {
    // this.get_members(this.team_id);
  },
  methods: {
    delete_member(player_two_id, team_id) {
      const formData = new FormData();
      formData.append('player_two_id', player_two_id);
      formData.append('team_id', team_id);

      this.$API.teams.delete_member(formData)
          .then(response => {
            this.$q.notify({
              message: 'Player Deleted .',
              color: 'green'
            })

            this.get_members(team_id);
          })
          .catch(error => {
            this.$toastr.e(error)
          });
    },
    add_new_member() {
      this.errors = [];
      this.loading = true;
      this.team_data.team_id = this.team_id;
      this.$API.teams.add_member(this.team_data)
        .then(response => {
          this.$q.notify({
            message: 'The invitation was sent successfully .',
            color: 'green'
          })
          this.loading = false;
          // this.get_members(this.team_id);

        })
        .catch(error => {
          this.loading = false;
          this.errors.push(error);
        });
    },
    get_members(team_id) {
      this.errors = [];
      this.loading = true;
      this.$API.teams.get_team_members(team_id)
        .then(response => {
          this.members = response.data;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.errors.push(error);
        });
    }
  }
}
</script>

<style>
.table {
  margin-top:10px;
  width:100%
}
td, th {
  border:1px gray solid;
  padding:5px;
}
</style>

